<template>
  <div class="body-wrapper">
    <div class="banner-wrapper">
      <div class="img-swiper">
        <!-- <swiper>
          <block wx:for="{{images}}">
            <swiper-item>
              <imgage ="item.img" style="height:180px;width:100%;border-radius:8px" />
            </swiper-item>
          </block>
        </swiper> -->
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(imageUrl, index) in hospInfo.bannerImageList" :key="index">
            <van-image lazy-load :src="imageUrl" style="height:180px;width:100%;border-radius:8px" fit="cover" />
          </van-swipe-item>
        </van-swipe>

        <div class="img-swiper--title">{{ hospInfo.name }}</div>
      </div>
    </div>
    <!-- <div class="order-wrapper module" style="display:none"
      v-show="moduleVisible('survey') || moduleVisible('personalAppointment') ||moduleVisible('companyAppointment')">
      <div class="module-title">体检预约</div>
      <div class="module-menu">
        <div class="module-menu-item" v-show="moduleVisible('survey')">
          <router-link to="/survey">
            <div class="module-menu-item-icon">
              <img src="@/assets/images/icon-order-survey.png" />
            </div>
            <div class="module-menu-item-name" style="font-size:16px;margin:-4px;">健康问卷</div>
          </router-link>
        </div>
        <div class="module-menu-item" v-show="moduleVisible('personalAppointment')">
          <router-link to="/packageList">
            <div class="module-menu-item-icon">
              <img src="@/assets/images/icon-order-personal.png" />
            </div>
            <div class="module-menu-item-name" style="font-size:16px;margin:-4px;">个人体检</div>
          </router-link>
        </div>
        <div class="module-menu-item" v-show="moduleVisible('companyAppointment')">
          <router-link to="/company/orderlist">
            <div class="module-menu-item-icon">
              <img src="@/assets/images/icon-order-company.png" />
            </div>
            <div class="module-menu-item-name" style="font-size:16px;margin:-4px;">团队体检</div>
          </router-link>
        </div>
      </div>
    </div> -->
    <div class="module-main">
      <div class="module-img-wrap">
        <router-link to="/packageList">
          <img :src="pic_url_personal" />
        </router-link>
      </div>
      <div class="module-img-wrap">
        <router-link to="/company/orderlist">
          <img :src="pic_url_company" />
        </router-link>
      </div>
    </div>
    <div class="service-wrapper module">
      <div class="module-title">体检服务</div>
      <div class="module-1">
        <van-row>
          <van-col span="6" v-show="moduleVisible('about')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'About' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_hospital" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('about') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('survey')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'Survey' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_survey" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('survey') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('notice')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'Notice' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_guideline" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('notice') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('location')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'Location' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_location" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('location') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('queue')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'queue' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_wait" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('queue') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('guideline')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'guideline' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_wait" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('guideline') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('reportList')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'reportlist' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_report" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('reportList') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('feedback')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'feedback' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_rating" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('feedback') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('companyTeamRegister')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'companyTeamRegister' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_contract" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('companyTeamRegister') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
          <van-col span="6" v-show="moduleVisible('articles')">
            <div class="module-menu-item">
              <router-link :to="{ name: 'ArticleList' }">
                <div class="module-menu-item-wrapper">
                  <div class="module-menu-item-icon icon-wrapper">
                    <img :src="icon_url_news" />
                  </div>
                  <div class="module-menu-item-name">{{ moduleName('articles') }}</div>
                </div>
              </router-link>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="recommand-wrapper module" v-if="packages && packages.length > 0">
      <div class="module-title">推荐套餐</div>
      <div class="package-wrapper">
        <router-link v-for="(pkg) in packages" :key="pkg.code" :to="{ path: '/packageDetail', query: { id: pkg.xh } }"
          class="package-row">
          <div class="package-img" :class="pkg.sex_limit == 2 ? 'package-img--female' : ''"></div>
          <div class="package-info">
            <div class="package-name">{{ pkg.name }}</div>
            <div class="package-desc">{{ pkg.remark }}</div>
            <div class="package-footer">
              <div class="package-price">￥{{ pkg.sale_price }}</div>
              <div class="package-order-count">{{ pkg.appoint_count }}人已预约</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="article-wrapper module" v-if="articles && articles.length > 0">
      <div class="module-title">最新消息</div>
      <div v-for="(item, index) in articles" :key="item.id">
        <router-link :to="{ path: '/article', query: { id: item.id } }" class="article-row">
          <div class="article-content">
            <div class="article-title">{{ item.title }}</div>
            <div class="article-footer">
              <span style="width:60px">{{ item.article_type_name }}</span>
              <span style="width:40px">浏览 {{ item.visit_count }}</span>
              <span>{{ item.update_time | fromNow }}</span>
            </div>
          </div>
          <div class="article-img" v-if="item.cover_url"></div>
        </router-link>
      </div>
      <div class="article-more">
        <router-link to="/articles">查看更多</router-link>
      </div>
    </div>
    <div class="footer">
      <div class="logo">
        <img :src="hospInfo.logoUrl" />
      </div>
      <div class="hosp-name">{{ hospInfo.name }}</div>
      <van-cell title="体检地址" icon="location-o" :value="hospInfo.address" />
      <van-cell title="联系电话" icon="phone-o" :value="hospInfo.phone" link-type="navigateTo"
        :url="`tel://${hospInfo.phone}`" />
      <van-cell v-for="(phone, index) in hospInfo.phones" :key="index" :title="phone.name" :value="phone.phoneNumber"
        link-type="navigateTo" :url="`tel://${phone.phoneNumber}`" class="other-phone" />
      <van-cell title="工作时间" icon="clock-o" :value="hospInfo.openHour" />
    </div>
    <footerTabbar :activeIndex="0" />
  </div>
</template>

<style lang="less" scoped>
.body-wrapper {
  background: #f9f9f9;
  padding-bottom: 60px;
}

.banner-wrapper {
  margin: 12px;
  background: #ffffff;
  border-radius: 8px;

  .img-swiper {
    //background-image: url("../assets/images/banner-2.jpg");
    background-size: 500px 180px;
    height: 180px;
    position: relative;

    /deep/ .van-image__img {
      border-radius: 8px;
    }
  }

  .img-swiper--title {
    content: "";
    line-height: 16px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0;
    background: #32323388;
    color: #ffffff;
    padding: 12px;
    border-radius: 0 0 8px 8px;
  }
}

.module-main {
  margin: 12px;
  display: flex;
  gap: 12px;

  .module-img-wrap {
    flex: 1;

    img {
      width: 100%;
    }
  }
}


.module {
  margin: 12px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;

  .module-title {
    font-size: 18px;
    font-weight: 500;
    line-height: 32px;
    display: block;
    text-align: center;
    position: relative;
    margin: auto;
    z-index: 2;
  }

  .module-title:after {
    content: " ";
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 4px;
    height: 8px;
    width: 50px;
    border-radius: 4px;
    background-color: var(--color-main);
    opacity: 0.25;
    z-index: 1;
  }

  .module-menu {
    display: flex;
  }

  .module-menu-item {
    flex: 1;
    justify-content: center;
    align-items: center;
    justify-items: center;
    text-align: center;
    padding: 10px 0;
  }

  .module-menu-item-icon {
    img {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      background: #eeeeee;
    }
  }

  .module-menu-item-name {
    text-align: center;
    margin: 6px 0;
    font-size: 14px;
  }

  .module-menu-item-desc {
    margin: 6px 0;
    font-size: 13px;
    color: #666666;
  }

  .package-wrapper {
    .package-row {
      display: flex;
      padding: 20px 8px;
      border-bottom: 1px solid #f2f2f2;

      &:last-child {
        border-bottom: 0;
      }

      .package-img {
        margin-right: 20px;
        width: 80px;
        height: 80px;
        background: #eeeeee;
        border-radius: 8px;
        background: #eeeeee;
        background-image: url('../assets/images/healthexam.png');
        background-size: cover;
        background-position: center;
      }

      .package-img--female {
        background-image: url('../assets/images/package-female.png');
      }

      .package-info {
        flex: 1;

        .package-name {
          font-size: 16px;
          margin-bottom: 8px;
        }

        .package-desc {
          min-height: 24px;
          font-size: 13px;
          margin: 8px 0;
          color: #666666;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .package-footer {
          margin-top: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          justify-items: center;

          .package-order-count {
            font-size: 13px;
            color: #666666;
          }

          .package-price {
            flex: 1;
            color: #fe8658;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
              sans-serif;
          }

          .package-price:first-letter {
            font-size: 12px;
          }
        }
      }
    }
  }
}

.service-wrapper {
  .module-menu-item {
    .module-menu-item-wrapper {
      border-radius: 10px;

      .icon-wrapper {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        margin: 0 auto;

        .van-icon {
          padding: 8px 0;
          display: block;
        }

        img {
          margin-top: 4px;
          width: 28px;
          height: 28px;
          background: none;
        }
      }

      .module-menu-item-name {
        text-align: center;
        margin: 0 0;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}

.article-wrapper {
  .article-row {
    display: flex;
    padding: 10px 0px;
    margin: 10px 8px;
    border-bottom: 1px solid #f2f2f2;

    .article-img {
      margin-left: 20px;
      width: 80px;
      height: 80px;
      background: #eeeeee;
    }

    .article-content {
      flex: 1;

      .article-title {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 10px;
      }

      .article-footer {
        color: #969799;
        font-size: 12px;

        span {
          margin-right: 20px;
        }
      }
    }
  }

  .article-more {
    padding: 8px;
    font-size: 14px;
    text-align: center;

    a {
      color: var(--color-main);
    }
  }
}

/deep/ .van-button--large {
  height: 42px;
  line-height: 42px;
}

.footer {
  margin: 12px;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px 0px;

  .logo {
    height: 60px;
    // border-radius: 30px;
    background: #fff;
    margin: 0 auto;
    text-align: center;

    img {
      height: 60px;
    }
  }

  .hosp-name {
    font-size: 18px;
    line-height: 40px;
    text-align: center;
  }

  .van-cell__title {
    flex: none;
    margin-right: 12px;
    color: #969799;
  }

  .van-cell__value {
    text-align: left;
    color: #323233;
  }

  .other-phone {
    .van-cell__title {
      flex: none;
      margin-left: 18px;
      margin-right: 12px;
      color: #969799;
    }
  }
}

.tabbar {
  background: #ffffff;
}
</style>

<script>
import Vue from "vue";
import {
  Row,
  Col
} from "vant";

Vue.use(Row).use(Col);
import {
  Swipe,
  SwipeItem,
  Lazyload
} from "vant";
Vue.use(Lazyload);
Vue.use(Swipe).use(SwipeItem);

import footerTabbar from "./components/footerTabbar.vue";
import {
  mapState,
  mapMutations,
  mapActions
} from "vuex";
import {
  getHospital,
  getHomePageModules,
} from '../api/hospital'
import {
  getPackages,
  getRecommandPackages,
} from '../api/package'
import {
  getArticles,
  getArticle,
} from '../api/article'

export default {
  components: {
    footerTabbar
  },
  data() {
    return {
      images: [{
        img: require("../assets/images/banner/banner-1.jpg")
      },
      {
        img: require("../assets/images/banner/banner-2.jpg")
      },
      {
        img: require("../assets/images/banner/banner-3.jpg")
      }
      ],
      recommandPackages: [],
      packages: [],
      articles: [],
      homePageModules: [],
    };
  },
  methods: {
    developing() {
      this.$Toast.fail("正在开发中");
    },
    ...mapActions(
      "hospital", {
      getHospitalInfo: "getHospitalInfo"
    }
    ),
    moduleVisible(code) {
      var module = this.homePageModules.find(it => {
        return it.code == code
      });
      if (module && module.status != 2) {
        return true;
      } else {
        return false;
      }
    },
    moduleName(code) {
      var module = this.homePageModules.find(it => {
        return it.code == code
      });
      if (module && module.status != 2) {
        return module.name;
      } else {
        return "未命名";
      }
    },
    getResourceUrl(resName) {
      if (!this.assets)
        return "";
      var res = this.assets.find(it => {
        return it.name == resName
      });
      if (!res)
        return ""
      else
        return res.value;
    },
  },
  async mounted() {
    if (this.$route.query.hospid) {
      let hospId = this.$route.query.hospid
      localStorage.setItem("hospid", hospId);
      this.getHospitalInfo(hospId);
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      getRecommandPackages(hospId).then(resp => {
        this.packages = resp.data;
        this.$toast.clear();
      }).catch(err => {
        console.log(err);
        this.$toast.clear();
      });

      getArticles(hospId, "", 0).then(res => {
        if (res.data && res.data.length > 0) {
          this.articles = res.data.slice(0, 5);
        }
      })

      getHomePageModules(hospId).then(res => {
        this.homePageModules = res.data;
      })
    } else {
      this.$router.push('/error')
    }
  },
  computed: {
    ...mapState({
      hospInfo: state => state.hospital.hospInfo,
      assets: state => state.hospital.assets
    }),
    icon_url_hospital() {
      return this.getResourceUrl('--icon-hospital');
    },
    icon_url_survey() {
      return this.getResourceUrl('--icon-survey');
    },
    icon_url_guideline() {
      return this.getResourceUrl('--icon-guideline');
    },
    icon_url_location() {
      return this.getResourceUrl('--icon-location');
    },
    icon_url_wait() {
      return this.getResourceUrl('--icon-wait');
    },
    icon_url_report() {
      return this.getResourceUrl('--icon-report');
    },
    icon_url_rating() {
      return this.getResourceUrl('--icon-rating');
    },
    icon_url_contract() {
      return this.getResourceUrl('--icon-contract');
    },
    icon_url_news() {
      return this.getResourceUrl('--icon-news');
    },
    pic_url_personal() {
      return this.getResourceUrl('--pic-personal');
    },
    pic_url_company() {
      return this.getResourceUrl('--pic-company');
    }
  },
};
</script>